// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"49b476a4","239":"39ef1dd4","249":"e678c50b","421":"c3a87f54","455":"6ea2799c","488":"7447843c","977":"0a1b413b"}[chunkId] + ".chunk.js";
};